import React from 'react';
import { getAutoVideo } from '../../../../../services/api';
import styles from './index.css';
import Title from '../../../components/title';

class AutoVideo extends React.PureComponent {
    static propTypes = {};
    constructor(props) {
        super(props);
        this.state = {
            autoVideoData: this.props.content,
        };
    }
    // async componentDidMount() {
    //     const autoVideoData = await getAutoVideo();

    //     this.setState({
    //         autoVideoData,
    //     });
    // }

    showVideoAutoView() {
        return (
            <ul className={styles.auto_ul}>
                <li className={styles.auto_first}>
                    <a target="_blank" href={this.state.autoVideoData[0].url}>
                        <img src={this.state.autoVideoData[0].posterUrl} />
                        <p className={styles.auto_title}>{this.state.autoVideoData[0].title}</p>
                        <em className={styles.auto_first_icon_video} />
                    </a>
                </li>
                <li className={styles.auto_ul_li}>
                    <a target="_blank" href={this.state.autoVideoData[1].url}>
                        <img src={this.state.autoVideoData[1].posterUrl} />
                        <p className={styles.auto_title}>{this.state.autoVideoData[1].title}</p>
                        <em className={styles.auto_icon_video} />
                    </a>
                </li>
                <li className={styles.auto_ul_li}>
                    <a target="_blank" href={this.state.autoVideoData[2].url}>
                        <img src={this.state.autoVideoData[2].posterUrl} />
                        <p className={styles.auto_title}>{this.state.autoVideoData[2].title}</p>
                        <em className={styles.auto_icon_video} />
                    </a>
                </li>
                <li className={styles.auto_ul_li}>
                    <a target="_blank" href={this.state.autoVideoData[3].url}>
                        <img src={this.state.autoVideoData[3].posterUrl} />
                        <p className={styles.auto_title}>{this.state.autoVideoData[3].title}</p>
                        <em className={styles.auto_icon_video} />
                    </a>
                </li>
                <li className={styles.auto_ul_li}>
                    <a target="_blank" href={this.state.autoVideoData[4].url}>
                        <img src={this.state.autoVideoData[4].posterUrl} />
                        <p className={styles.auto_title}>{this.state.autoVideoData[4].title}</p>
                        <em className={styles.auto_icon_video} />
                    </a>
                </li>
            </ul>
        );
    }

    render() {
        return (
            <div className={styles.auto_video}>
                {this.state.autoVideoData && this.state.autoVideoData.length > 0 ? (
                    <div>
                        <Title content="汽车视频" />
                        {this.showVideoAutoView()}
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default AutoVideo;
